module.exports = __webpack_public_path__ + "static/img/green-plant.a39a640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/product/green-plant.jpg
// module id = YHyk
// module chunks = 1